export const PHONE_REGEX_DEFAULT = '^[1-9][0-9]';
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
export const PLATE_REGEX = '^[a-zA-Z0-9]{7,8}$';
export const CONSENT_TYPE = {
    OLX: 'OLX',
    GPLUS: 'gplus'
};

export const USER_TYPE = {
    COCO: 'OLX_Autos',
    FOFO: 'Franchise',
    PREFFERED: 'preffered',
    REGULAR: 'regular'
};
export const KYC = {
    VERIFIED: 'verified'
};
export const SELLER_VERIFICATION_STATUS = 'verified';

export const OTP_AUTOREAD_EXPERIMENT_KEY = 'PAN-62408';

export const SETTINGS_STATIC_CONSENTS_LIST = [
    {
        key: 'email',
        title: 'consent_email_title',
        defaultTitle: 'E-mail',
        subtitle: 'consent_email_subtitle',
        defaultSubtitle: 'I want to receive email notification about promotions'
    },
    {
        key: 'sms',
        title: 'consent_sms_title',
        defaultTitle: 'SMS',
        subtitle: 'consent_sms_subtitle',
        defaultSubtitle: 'I want to receive SMS messages about promotions'
    },
    {
        key: 'whatsapp',
        title: 'consent_whatsapp_title',
        defaultTitle: 'Whatsapp',
        subtitle: 'consent_whatsapp_subtitle',
        defaultSubtitle: 'I want to receive Whatsapp messages about promotions'
    },
    {
        key: 'phone',
        title: 'consent_phone_title',
        defaultTitle: 'Phone',
        subtitle: 'consent_phone_subtitle',
        defaultSubtitle: 'I want to receive phone calls about promotions'
    }
];

/* BELOW ATTR DECIDES A LOGGED-IN USER AS PREMIUM VS FREE */
export const PREMIUM_USER_TYPE = {
    PREMIUM: 'user_premium',
    SUPER_USER: 'user_superdealer'
};

/* BELOW ATTR DECIDES WHETHER AD POSTED BY USER IS PREMIUM VS FREE. THIS HAS BEEN IN SYNC WITH BACKEND SERVICES */
export const USER_SELLER_TYPE = {
    SELLER_TYPE_PREMIUM: 'seller-type-premium',
    SELLER_TYPE_SUPER_USER: 'seller-type-super-diler'
};

